<template>
  <!-- Keeps the .root_order_total class so Order.vue's fly-to-cart target stays valid. -->
  <button
    type="button"
    class="root_order_total"
    :class="{ 'root_order_total--pulsing': pulsing }"
    @click="$emit('open')"
  >
    <i class="material-icons-round cart-ico" aria-hidden="true">shopping_cart</i>
    <span class="cart-count">{{ itemCountLabel }}</span>
    <span class="cart-sep">•</span>
    <span class="text_total_order">$ {{ formattedTotal }}</span>
  </button>
</template>

<script>
// Ported from advocado FloatingCartPill (MTH022). MOO keeps the pill docked
// (not fixed) and always visible; this port only adds the pulse-on-add feedback.
export default {
  name: "FloatingCartPill",
  props: {
    itemCount: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    // Bump this to trigger a brief pulse (e.g. on add-to-cart).
    pulseToken: { type: Number, default: 0 },
  },
  emits: ["open"],
  data() {
    return {
      pulsing: false,
      pulseTimer: null,
    };
  },
  watch: {
    pulseToken() {
      if (this.pulseTimer) clearTimeout(this.pulseTimer);
      // Toggle off first so the keyframe restarts on rapid consecutive adds.
      this.pulsing = false;
      this.$nextTick(() => {
        this.pulsing = true;
        this.pulseTimer = setTimeout(() => {
          this.pulsing = false;
          this.pulseTimer = null;
        }, 260);
      });
    },
  },
  unmounted() {
    if (this.pulseTimer) clearTimeout(this.pulseTimer);
  },
  computed: {
    // Singular/plural picked here rather than through vue-i18n pluralisation:
    // the CJK/Thai bundles use one form for both.
    itemCountLabel() {
      const key = this.itemCount === 1 ? "cart.itemPillOne" : "cart.itemPillMany";
      return this.$t(key, { count: this.itemCount });
    },
    formattedTotal() {
      return Number(this.total || 0).toFixed(2);
    },
  },
};
</script>

<style scoped>
.root_order_total {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 7px;
  width: max-content;
  max-width: 100%;
  white-space: nowrap;
  background: var(--color);
  color: #ffffff;
  padding: 9px 18px;
  border: none;
  border-radius: 999px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 4px 12px;
  cursor: pointer;
  font-family: inherit;
}
.root_order_total .cart-ico {
  font-size: 19px;
  color: #ffffff;
  flex-shrink: 0;
}
.root_order_total .cart-count,
.root_order_total .cart-sep {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  flex-shrink: 0;
}
.root_order_total .text_total_order {
  font-size: 15px;
  font-weight: 800;
  color: #ffffff;
  white-space: nowrap;
  flex-shrink: 0;
}
.root_order_total:active {
  transform: scale(0.96);
}

/* MTH022: brief scale pulse to acknowledge an add-to-cart landing. */
@keyframes cart-pill-pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.06);
  }
}
.root_order_total--pulsing {
  animation: cart-pill-pulse 250ms ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .root_order_total--pulsing {
    animation: none;
  }
}
</style>
